export default {
    CreateSettlementTitle: 'Escolha uma operadora',
    createSettlementDescription: 'Para continuar, selecione uma das seguintes opções',
    coverageSelection: 'Cobertura',
    coverageSelectionDescription: 'Escolha uma ou mais das seguintes opções',
    cutoffTitle: 'Período de corte',
    cutoffDescription: 'Selecione um período, início e término',
    error: 'Ocorreu um erro na criação do envio',
    steper: {
        sponsorSelection: 'Seleção de operadora',
        authorizations: 'Autorizações',
    },
    buttons: {
        next: 'Continuar',
        back: 'Voltar',
        cancel: 'Cancelar',
        end: 'Terminar',
        changeSponsor: 'Mudar',
    },
    title: {
        text: 'Novo envio',
        back: 'Cancelar',
    },
    dates: {
        init: 'De',
        final: 'Até',
    },
    authorizations: {
        cutoffRange: 'Período de corte',
        totalResults: '{total} resultados',
        selectedRows: '{selected} selecionados',
        chooseTitle: 'Escolha as autorizações que deseja enviar',
        chooseDescription: 'Você pode desmarcar autorizações',
        selectAll: 'Selecionar tudo',
        grid: {
            id: 'ID',
            createdAt: 'Data de criação',
            beneficiaryName: 'Beneficiário',
            memberCode: 'Carteirinha',
            coverage: 'Cobertura',
        }
    },
    billing: {
        title: 'Concluir envio',
        subtitle: 'Insira as seguintes informações',
        quantitySubtitle: 'Não há autorizações para enviar | 1 autorização para enviar | {n} autorizações para enviar',
        complete: 'Finalizar',
        invoiceNumber: {
            label: 'Número da nota fiscal',
            placeholder: 'Número da nota fiscal',
        },
        invoiceDate: {
            label: 'Data da conta',
            placeholder: 'Data da conta',
        },
        invoiceAmount: {
            label: 'Valor total da conta',
            placeholder: 'Valor total da conta',
        },
        taxReceiptNumber: {
            label: 'NCF',
            placeholder: 'NCF',
        },
        taxReceiptNumberExpirationDate: {
            label: 'Data de vencimento do comprovante fiscal',
            placeholder: 'Data de vencimento do comprovante fiscal'
        },
        invoiceFile: {
            label: 'documento de fatura',
            placeholder: 'Arraste e solte ou',
            placeholderDrag: 'Arraste e solte',
            upload: 'Carregar arquivo',
            replace: 'Substituir',
        },
        creditNoteFile: {
            label: 'Nota de crédito (opcional)',
            placeholder: 'Arraste e solte ou',
            upload: 'Subir arquivo',
            placeholderDrag: 'Arraste e solte',
            replace: 'Substituir',
        },
        debitNoteFile: {
            label: 'Nota de débito (opcional)',
            placeholder: 'Arraste e solte ou',
            upload: 'Subir arquivo',
            placeholderDrag: 'Arraste e solte',
            replace: 'Substituir',
        },
        errors: {
            multipleFileUpload: 'Apenas um arquivo pode ser carregado por vez',
            fileTypeIncorrect: 'Tipo de arquivo errado',
        }
    }
}
